import React from 'react'
import moment from 'moment'
import { GlobalContext, UserContext } from 'components/context'
import { ActionButton } from 'components/Buttons'
import { normalizeStatus, currentActiveKeys } from 'helpers'
import ActivationSuccess from './ActivationSuccess'

const invalidStatus = (status) =>
  ['cancelled', 'stopped'].includes(normalizeStatus(status))

const ActivateRFID = () => {
  const { membership } = React.useContext(UserContext)
  const { t } = React.useContext(GlobalContext)
  const { put } = React.useContext(UserContext)
  const [code, setCode] = React.useState(null)
  const [success, setSuccess] = React.useState(null) // eslint-disable-line no-unused-vars
  const [error, setError] = React.useState(null) // eslint-disable-line no-unused-vars
  const [isSubmitting, setIsSubmitting] = React.useState(false)
  const { logEvent } = React.useContext(UserContext)

  // We should only show the generate PIN option if the member has no access
  const [hasAccess, setHasAccess] = React.useState(membership.keys &&
    membership.keys.length > 0 &&
    currentActiveKeys(membership.keys).length > 0)
  const [pin, setPin] = React.useState(null)

  if (!membership) return null

  // // TODO: Display error about status or redirect?
  if (invalidStatus(membership.status)) return null

  const params = new URLSearchParams(window.location.search)
  const action = params.get('action')
  const prefix = 'pages.membership.access.rfid'

  if (success) return <ActivationSuccess code={code} />

  const phrase = (suffix) => {
    return `${prefix}.${suffix}`
  }

  let steps
  try {
    steps = t(phrase('activate.how_steps'), { returnObjects: true })
  } catch (err) {
    console.error(err)
    steps = [`Malformed translation for ${phrase('activate.how_steps')}`]
  }

  const onChange = (e) => {
    setCode(e.target.value)
  }

  const onSubmit = (e) => {
    e.preventDefault()

    if (isSubmitting) return

    setIsSubmitting(true)

    put('rfids', { code })
      .then(res => {
        setSuccess(res)
        logEvent('activated_rfid_access')
      })
      .catch(err => {
        setError(err)
        console.error(err)
      })
      .finally(() => {
        setIsSubmitting(false)
      })
  }

  const generatePin = (e) => {
    e.preventDefault()

    if (isSubmitting) return

    setIsSubmitting(true)

    const payload = {
      valid_from: moment().format('YYYY-MM-DD'),
      valid_to: moment().add(membership.access_chip.pin_days, 'days').format('YYYY-MM-DD'),
    }

    put('pin', payload)
      .then(res => {
        setPin(res)
        setHasAccess(true)
        logEvent('generated_pin')
      })
      .catch(err => setError(err))
      .finally(() => {
        setIsSubmitting(false)
      })
  }

  const formRfid = () => {
    return (
      <React.Fragment>
        <form onSubmit={onSubmit} style={{ marginTop: '50px' }}>
          <p>{ t(phrase('activate.enter_code')) }</p>
          <label onChange={onChange}>
            { t(phrase('label')) }
            <input type={'text'} />
          </label>
          <ActionButton type={'submit'} disable={isSubmitting.toString()} value='rfids'>
            { t(phrase('activate.button')) }
          </ActionButton>
        </form>
      </React.Fragment>
    )
  }

  const actionSection = () => {
    if (!hasAccess) {
      return (
        <React.Fragment>
          <ActionButton type={'button'} onClick={generatePin} disabled={isSubmitting} value='pin'>{t(phrase('send_pin'))}</ActionButton>
        </React.Fragment>
      )
    }

    return formRfid()
  }

  const showPin = () => {
    if (!pin) return null

    return (
      <React.Fragment>
        <p className='pin'>{t(phrase('pin_code'))}<b>{pin.key.code}</b></p>
        <p className='date'>{t(phrase('pin_valid'))}<b>{pin.key.valid_to?.substring(0, 10)}</b></p>
      </React.Fragment>
    )
  }

  // set the rfid replacement cost
  const cost = t(phrase('activate.lost_info.replacement_cost'), { fee: membership.access_chip.fee / 100 })

  return (
    <div className='activate'>
      <section className={`loading ${isSubmitting ? '' : 'invisible'}`}>
        <div className={`centred ${isSubmitting ? '' : 'invisible'}`}>
          <img src='/images/LoaderCredlock.gif' alt='processing...' width='62' height='62' />
        </div>
      </section>
      <h1>{t(phrase('title'))}</h1>
      <h3>{t(phrase('activate.how_title'))}</h3>
      <p>{t(phrase('activate.how_it_works'))}</p>
      <ol className='steps'>
        {
          Array.isArray(steps) && steps.map((step, idx) => {
            return (
              <React.Fragment key={idx}>
                <li key={idx} className='step'>
                  <h3>{step.header}</h3>
                  <p>{step.details}</p>
                </li>
              </React.Fragment>
            )
          })
        }
      </ol>
      <h3>{t(phrase('activate.lost_info.header'))}</h3>
      <p>{t(phrase('activate.lost_info.details'), { cost: cost })}</p>
      {action === 'activate' && <p className='warn'>{t(phrase('switch'))}</p>}
      {action === 'switch' && <p className='warn'>{t(phrase('activate.disable_nfc'))}</p>}
      {pin && showPin()}
      {actionSection()}
    </div>
  )
}

export default ActivateRFID
